const RESOURCES_EN = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "BTP Pro Card",
  CACES: "CACES",
  CE_CERTIFICATE: "CE Certificate",
  CE_CERTIFICATION: "CE Certification",
  DELIVERY: "Delivery",
  DEPARTURE_NOTE: "Departure Note",
  DRIVING_AUTHORIZATION: "Driving Authorization",
  DUE: "Due",
  documentsStatus: "Documents status",
  EMAILS: "Email",
  HOUR_SHEET: "Hour Sheets",
  ICON: "Icon",
  ID: "ID",
  IDENTITY: "Identity",
  INSURANCE: "Insurance",
  INVOICE: "Invoice",
  KBIS: "Kbis",
  LIFTING_PLAN: "Lifting Plan",
  LIFTING_SHEET: "Lifting Sheet",
  LOGO: "Logo",
  MACHINE_SPECIFICATIONS: "Machine Specifications",
  MAINTENANCE_LOG: "Maintenance Log",
  MAINTENANCE_LOG_EXCERPT: "Maintenance Log Excerpt",
  MEDICAL_CERTIFICATE: "Medical Certificate",
  OPERATOR_DOCUMENT: "Operator Document",
  OTHER: "Other",
  PGI: "PGI",
  PHOTO: "Photo",
  PIC: "PIC",
  PURCHASE_ORDER: "Purchase Order",
  QUOTATION: "Quotation",
  RETURN_NOTE: "Return Note",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "Signed Rental Request",
  SPECIFIC_TRAINING: "Specific Training",
  TECHNICAL_SHEET: "Technical Sheet",
  USED_MACHINE_CERTIFICATE: "Used Machine Certificate",
  USER_MANUAL: "User Manual",
  VGP: "VGP",
  WORK_ORDER: "Work Order",
} as const;

export default RESOURCES_EN;
